import * as REQUESTERCONSTANTS from '../constants/requesterConstants';

// TODO: Removed constant in files.
// TODO: 4eslint issues to be removed.

import * as stringConstants from '../constants/stringConstants';
export const getHeading = () => {
  const currentPath = window.location.pathname.toLowerCase();
  if(currentPath === '/vendorintake' || currentPath.includes('/vendorintake/')) {
    return 'Supplier Registration Form';
  }
  else if(currentPath.includes('/vendorinformation')) {
    return 'Supplier Information Review';
  }
  else {
    return 'Page Not Found';
  }
};

export const isObjectEmpty = (obj) => Object.keys(obj).length === 0;

export const submitOrButton = (page, lastPageNum) => {
  return page === lastPageNum ? 'submit' : 'button';
};

export const nextOrSubmit = (page, lastPageNum, isEditClicked = false) => {
  if (isEditClicked === true) {
    return 'Save';
  }
  return page === lastPageNum ? 'Submit' : 'Next';
};

export const fetchRes = (res) => res.data && res.data.status === 'failure';

export const loadUserAdminFunction = (value) => {
  if (
    value === 'OCR Admin Group'
    || value === 'SSO_StreamDisbursements_PTUUserAdmin_group'
  ) {
    return true;
  }
};

export const loadUserVerifierFunction = (value) => {
  if (
    value === 'SSO_PA_US_CBR_Payment_Requester'
    || value === 'SSO_PA_Internal_Payment_Requester'
    || value === 'SSO_PA_US_CBR_Payment_Requester'
  ) {
    return true;
  }
};

export const fetchResponseError = (err) => err.response
 && err.response.data && err.response.data.message;

export const showDataError = (
  setShowErrorDialog,
  setErrorMsg,
  setShowCloseIcon,
  res
) => setShowErrorDialog(1)
  && setErrorMsg(res.data.message || REQUESTERCONSTANTS.COOKIE_ERROR)
  && setShowCloseIcon(false);

export const dataLoopAddition = (data, string) => {
  const result = [];
  data.map((field, index) => {
    result.push(field.concat(' - ', string));
  });
  return result;
};

export const getSupplierRequestStatus = (supplierStatus) => {
  switch(supplierStatus){
    case stringConstants.VENDOR_SUBMITTED:
      return 'Vendor Submitted';
    case stringConstants.REQUESTOR_APPROVED:
      return 'Requestor Approved';
    case stringConstants.REQUESTOR_REJECTED:
      return 'Requestor Rejected';
    case stringConstants.SUPERVISOR_APPROVED:
      return 'Supervisor Approved';
    case stringConstants.SUPERVISOR_REJECTED:
      return 'Supervisor Rejected';
    case stringConstants.SUPERVISOR_RETURN_TO_REQUESTOR:
      return 'Supervisor Returned';
    case stringConstants.ADMIN_APPROVED:
      return 'Admin Approved';
    case stringConstants.ADMIN_REJECTED:
      return 'Admin Rejected';
    case stringConstants.ADMIN_RETURN_TO_REQUESTOR:
      return 'Admin Returned';
    default:
      return ''; 
  }
}

export const isCountryChinaOrJapan = (countryName) => {
  switch (countryName?.toLowerCase()) {
    case 'china':
      return true;
    case 'japan':
      return true;
    case 'taiwan':
      return true;
    default:
      return false;
  }
}

export const isCountryJapan = (countryName) => {
  return countryName?.toLowerCase() === 'japan';
};

export const isCountrySweden = (countryName) => {
  return countryName?.toLowerCase() === 'sweden';
};

export const isCountryPhilippenes = (countryName) => {
  return countryName?.toLowerCase() === 'philippines';
};